export default __webpack_public_path__ + "static/imageSecondSection-0f5d6bfe2241fe8a6c7d8f521d3aed2f.svg";